import { LocalStorageKeys } from "@repo/logic";
import { useQueryClient } from "@tanstack/react-query";
import { navigate } from "gatsby";
import { useEffect } from "react";
import { useParams } from "./useParams";

export const useClearCache = (redirectUrl?: string): null => {
    const queryClient = useQueryClient();
    const [isLogout] = useParams({
        name: "logout",
        required: false,
    });
    // clear cache on logout
    useEffect(() => {
        if (isLogout && isLogout === "true") {
            localStorage.removeItem(LocalStorageKeys.REACT_QUERY_OFFLINE_CACHE);
            queryClient.removeQueries();
            queryClient.clear();
            if (redirectUrl) {
                navigate(redirectUrl);
            }
        }
    }, [isLogout]);
    return null;
};
